var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowerTools(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 63,
    viewBox: "0 0 69 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.9751 12.957H57.8828V16.9892H66.9751C68.0915 16.9892 68.9965 16.0865 68.9965 14.9731C68.9965 13.8597 68.0915 12.957 66.9751 12.957Z",
    fill: "#221E3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4937 6.47852H47.0625V23.4674H47.4937C51.0082 23.4674 53.8457 20.6318 53.8457 17.1325V12.8135C53.8457 9.37187 51.0557 6.47852 47.4937 6.47852Z",
    fill: "#221E3F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6652 0H10.6823C4.77246 0 0 4.77221 0 10.6539V27.9295C0 29.0429 0.905086 29.9456 2.02149 29.9456H36.6652C40.1796 29.9456 43.0172 27.1103 43.0172 23.6107V6.33495C43.0172 2.89322 40.2273 0 36.6652 0ZM12.704 19.2917C12.704 20.4051 11.7989 21.3078 10.6825 21.3078C9.56607 21.3078 8.66099 20.4051 8.66099 19.2917V10.6538C8.66099 9.54039 9.56607 8.63772 10.6825 8.63772C11.7989 8.63772 12.704 9.54039 12.704 10.6538V19.2917ZM21.3648 19.2917C21.3648 20.4051 20.4597 21.3078 19.3433 21.3078C18.2269 21.3078 17.3218 20.4051 17.3218 19.2917V10.6538C17.3218 9.54039 18.2269 8.63772 19.3433 8.63772C20.4597 8.63772 21.3648 9.54039 21.3648 10.6538V19.2917Z",
    fill: "#4A3A80"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0703 40.7436H30.1732C31.2896 40.7436 32.1947 39.8409 32.1947 38.7275V33.9785H27.7833L25.0703 40.7436Z",
    fill: "#4A3A80"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8385 47.5087C24.0748 47.5087 22.4317 46.6394 21.4432 45.1834C20.4545 43.7272 20.2554 41.8827 20.9104 40.2494L23.4254 33.9785H5.85746C5.83562 34.3925 5.74789 34.8058 5.58914 35.2017L1.07381 46.4598C0.361307 48.2359 0 50.1067 0 52.0201V60.3221C0 61.4355 0.905086 62.3381 2.02149 62.3381H25.839C26.9554 62.3381 27.8605 61.4355 27.8605 60.3221V49.5248C27.8605 48.4114 26.955 47.5087 25.8385 47.5087Z",
    fill: "#4A3A80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerTools);
export default __webpack_public_path__ + "static/media/power_tools.a6459027d4d33bde6f3e972ac4e37826.svg";
export { ForwardRef as ReactComponent };